/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { Text } from "react-native";
import { humanize } from "uno-js";

export const CustomToastVW = (props: any) => {
    return (
        <div style={styles.cardStyle}>
            <Text style={{ fontSize: 14, fontWeight: "600", display:'flex', color:'red' }}>
                {humanize(props?.message)}
            </Text>
            {props?.errorCode ? (
                <Text
                    style={{ fontSize: 12, color: "red" }}
                >{`Error code: ${props?.errorCode}`}</Text>
            ) : null}
        </div>
    );
};

const styles = {
    cardStyle: {
        minHeight: 70,
        backgroundColor:'#fff',
        boxShadow: `0 4px 8px 0 rgba(0,0,0,0.2)`,
        transition: `0.3s`,
        padding: 15,
        borderLeft: "4px solid red",
        borderRadius: 10,
        zIndex:9
    },
};
